import moment from 'moment-timezone';

export default function isSleeping(user) {
  return (
    moment().diff(user.data.sleepingStartingAt) > 0 &&
    moment().diff(user.data.sleepingEndingAt) < 0
  );
}
